import _      from 'lodash'
import React  from 'react'
import Select from './select'

export default BooleanSelect = (props) ->
  options = { '--': null, 'ano': true, 'ne': false }

  <Select options={options} onChange={props.onChange} />
